// Import Styles
import '../sass/styles.scss';

// Import Plugins
// import 'bootstrap';

// Import JS Class
import './slider/homepage-featured';
import './slider/post-related';

import navigationBurgerMenu from './helpers/navigationBurgerMenu.js';
import navigationScroll from './helpers/navigationScroll';
import doubleTapToGo from './helpers/doubleTapToGo.js';

(function () { 
    $(document).ready(function() 
    {
        // Initialize Navigation Burger Menu
        navigationBurgerMenu('.js-burger-menu', '.js-site-header-side', '.js-site-side-header__close');

        // Initialize Navigation Sub Menu Scrolling
        navigationScroll('.sub-menu');

        // Initialize Navigation Double Tap to Go Functionality
        doubleTapToGo('.menu-item-has-children > a');

        if ( $(window).width() < 768 )
        {
            $('.js-collapse__title').on('click', function() {
                $(this).toggleClass('active');
                $(this).next('.js-collapse__body').toggleClass('active');
            });
        }

        // Search Popup

        $('.js-header-bottom--mobile__search').on('click', function() {
            $('.js-search-form').addClass('active');
        });

        $('.js-search-form__close').on('click', function() {
            $('.js-search-form').removeClass('active');
        });

        // Categories
        var categoryNavigation = $('.js-posts-categories');

        $('.js-posts-categories-next').on('click', function() {
            var leftPosition = categoryNavigation.scrollLeft();
            categoryNavigation.animate({
                scrollLeft: leftPosition + 200,
            }, 300);
        });

        $('.js-posts-categories-previous').on('click', function() {
            var leftPosition = categoryNavigation.scrollLeft();
            categoryNavigation.animate({
                scrollLeft: leftPosition - 200,
            }, 300);
        });

        // Two Tone Titles
        if(!$('body').hasClass('search'))
        {
            $('h1, h2, .h1, .h2').each(function () {
                const title = $(this);
                const text = title.text();
                const words = text.split(' ');
                // const halfIndex = Math.ceil(words.length / 2);
                const halfIndex = 2
                const firstHalf = words.slice(0, halfIndex).join(' ');
                const secondHalf = words.slice(halfIndex).join(' ');
        
                // Wrap each half in a span with a class for styling
                title.html(`<span class="black-half">${firstHalf}</span><span class="red-half">${secondHalf}</span>`);
            });
        }

        // Accordion 
        $('.js-accordion-title').on('click', function() {
            var content = $(this).next('.js-accordion-content');
            $(this).toggleClass('active');
            content.toggleClass('active');
        });
    });

    $(window).scroll(function() {
        /**
         * Sticky Sidebar on Articles 
         */
        if ( ( $(window).width() >= 992) && $('.js-sticky-sidebar').length ) 
        {
            let article = $('.l-post');
            let stickySidebar = $('.js-sticky-sidebar');
            let stickySidebarHeight = stickySidebar.outerHeight();
            let stickySidebarWidth = stickySidebar.outerWidth();
            let stickySidebarOffsetFromRight = $(window).width() - (stickySidebar.offset().left + stickySidebarWidth);
            let bannerHeight = $('.js-header-image').outerHeight();
            let articleHeight = article.outerHeight();
    
            // Offset from the top of the window to the bottom of the banner image
            let offsetToArticle = headerOffset + bannerHeight;
            // Offset from the top of the window to the bottom of the article
            let offsetToBottomArticle = article.offset().top + articleHeight
            // Height of sticky sidebar adjusted for offset from header & overlap positioned article (30px)
            let offsetStickySidebar = bottomHeaderHeight + stickySidebarHeight;

            // If we have a legal notice
            if ( $('.js-notice-legal').length )
            {
                bottomHeaderHeight = bottomHeaderHeight + $('.js-notice-legal').outerHeight();
            }

            // If we have a legal notice
            if ( $('.c-notice-slider').length )
            {
                bottomHeaderHeight = bottomHeaderHeight + $('.c-notice-slider').outerHeight();
            }
    
            if ($(window).scrollTop() >= offsetToArticle) 
            {
                if ($(window).scrollTop() < offsetToBottomArticle - offsetStickySidebar) // In Article
                {
                    setStickySidebarProperties('fixed', bottomHeaderHeight, stickySidebarOffsetFromRight, 'unset');
                } 
                else // Below Article
                {
                    setStickySidebarProperties('absolute', 'unset', -(stickySidebarWidth + 15), 0);
                }
            } 
            else // Above Article
            {
                setStickySidebarProperties('absolute', 0, -(stickySidebarWidth + 15), 'unset');
            }
        }

        // Back to Top
        if ($(this).scrollTop() > 100) 
        {
            $(".js-back-to-top").fadeIn();
        } 
        else 
        {
            $(".js-back-to-top").fadeOut();
        }
    });

    function setStickySidebarProperties(position, top, right, bottom) 
    {
        let stickySidebar = $('.js-sticky-sidebar');
        stickySidebar.css('position', position);
        stickySidebar.css('top', top);
        stickySidebar.css('right', right);
        stickySidebar.css('bottom', bottom);
    }

})();